import React, { useState, useEffect } from 'react';
import { Flex, Box, Image, Text } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import logoImg from '../../Images/icon/logo.svg';
import header from '../../Images/icon/header.svg';

export default function Navbar(props) {
  const [scrolled, setScrolled] = useState(window.scrollY > 0);
  const navHeight = '62px';
  const history = useHistory();

  const handleScroll = () => setScrolled(window.scrollY > 0);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  function logout() {
    sessionStorage.clear();
    history.push('/');
  }

  function goHome() {
    history.push('/home');
  }

  return (
    <Box w="100vw">
      <Flex
        w="100%"
        h={navHeight}
        px="28px"
        py="12px"
        align="center"
        justify="space-between"
        top={0}
        position="sticky"
        bg="#EBFCF4"
        bgImg={header}
        bgSize="cover"
        boxShadow={scrolled ? '0px 5px 10px rgba(0, 0, 0, 0.05)' : 'none'}
        zIndex={1000}
        borderBottom="#1C734A 3.5px solid"
      >
        <Flex align="center">
          <Image src={logoImg} />
          <Text fontSize="xl" color="#0B4654" ml="15px">
            化學雲區塊鏈應用
          </Text>
        </Flex>

        <Flex align="center" gap="24px" mr="8px">
          <Text
            fontFamily="Open Sans"
            fontSize="20px"
            fontWeight="400"
            lineHeight="150%"
            letterSpacing="1%"
            color="#0B4654"
            cursor="pointer"
            onClick={goHome}
            _hover={{ textDecoration: 'underline' }}
          >
            首頁
          </Text>
          <Text
            fontFamily="Open Sans"
            fontSize="20px"
            fontWeight="400"
            lineHeight="150%"
            letterSpacing="1%"
            color="#0B4654"
            cursor="pointer"
            onClick={logout}
            _hover={{ textDecoration: 'underline' }}
          >
            登出
          </Text>
        </Flex>
      </Flex>

      <Flex
        height="calc(100vh - 62px)"
        overflowY="auto"
        overflowX="hidden"
        w="100%"
      >
        {props.children}
      </Flex>
    </Box>
  );
}
